import { getApiBaseUrl } from "src/config/endpoints";

const API_BASE_URL = getApiBaseUrl();

export interface SourceResponse {
  status: boolean;
  source_ids: number[];
}

/**
 * Fetch connected sources from the API.
 * @param tenantId - The tenant ID stored in localStorage.
 * @param apiKey - The API key stored in localStorage.
 * @returns Promise resolving to SourceResponse.
 */
export const fetchConnectedSources = async (
  tenantId?: string | null,
  apiKey?: string | null
): Promise<SourceResponse | null> => {
  try {
    if (!tenantId || !apiKey) {
      console.warn("Missing tenantId or apiKey");
      return null;
    }

    const response = await fetch(`${API_BASE_URL}/sources-connected`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        // "X-Tenant-ID": tenantId,
        Authorization: `Bearer ${apiKey}`,
      },
      body: JSON.stringify({ tenant_id: tenantId }),
    });

    // if (response.status === 401) {
    //   navigate("/log-in");
    //   return null;
    // }

    if (!response.ok) {
      //console.error("Failed to fetch sources:", response.statusText);
      return null;
    }

    const data = await response.json();
    return {
      status: data.status || false,
      source_ids: Array.isArray(data.source_ids) ? data.source_ids : [],
    };
  } catch {
    console.error("Error fetching sources");
    return null;
  }
};
